import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class SwipeCardsProps {
  @Inlet(Accepts.Image) public headerImage?: Types["Image"];
  @Inlet(Accepts.MarkdownText) public introduction?: Types["MarkdownText"];
  @Inlet(Accepts.Image) public leftButtonIcon?: Types["Image"];
  @Inlet(Accepts.Image) public rightButtonIcon?: Types["Image"];
  @Inlet(Accepts.SwipeCardList) public cards?: Types["SwipeCardList"];
  @Inlet(Accepts.Boolean) public isRequired?: Types["Boolean"];
  @Inlet(Accepts.Boolean) public randomize?: Types["Boolean"];
}

export const SwipeCardsDefinition = defineElement(
  "swipe-cards",
  SwipeCardsProps,
  {
    versionRequired: "0.80.0",
  }
);

export const SWIPE_CARDS_ACTIONS = {
  onAllSwiped: "on-all-swiped",
};
